module.exports = __webpack_public_path__ + "static/thumbnail-40490a677de48887a15c61571c0cf2b5.png";